import { combineReducers } from 'redux';

import payoutFees from './payoutFees';
import payoutRequestDetails from './payoutRequestDetails';
import payoutRequests from './payoutRequests';
import payoutRequestAvailability from './payoutRequestAvailability';


export default combineReducers({
  payoutFees,
  payoutRequestDetails,
  payoutRequests,
  payoutRequestAvailability,
});
